import { STAGE } from "../shared/constants/env";

export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig();

  function getStage() {
    const stage = config?.public?.stage;
    return typeof stage === "string" ? stage.toLowerCase() : "";
  }

  function isStage(stages: (keyof typeof STAGE)[] | string[]) {
    const stage = getStage();

    return stages.includes(stage);
  }

  function isDevelopment() {
    return isStage([STAGE.local, STAGE.dev, STAGE.test, STAGE.acc]);
  }

  function isProduction() {
    return isStage([STAGE.stg, STAGE.prod, STAGE.live]);
  }

  function showDevMessage() {
    return isStage([STAGE.local, STAGE.dev, STAGE.test, STAGE.acc, STAGE.stg]);
  }

  return {
    provide: {
      isStage,
      getStage,
      isDev: isDevelopment(),
      isProd: isProduction(),
      showDevMessage: showDevMessage(),
    },
  };
});
